const SubstationVisnetHub = () =>
  import(/* webpackChunkName: "visnet-hub" */ '@/components/substations/substation-visnet-hub');
const Charts = () =>
  import(
    /* webpackChunkName: "visnet-hub-chart" */ '@/components/substations/visnet-hubs/landing-visnet-hub-default-charts'
  );
const ElectricalChart = () =>
  import(
    /* webpackChunkName: "visnet-hub-chart" */ '@/components/substations/visnet-hubs/main-view/phases-feeders/electrical/electrical-chart-filtration'
  );
const EnvironmentalChart = () =>
  import(
    /* webpackChunkName: "visnet-hub-chart" */ '@/components/substations/visnet-hubs/main-view/environmental/environmental-chart-filtration'
  );
const PowerQualityChart = () =>
  import(
    /* webpackChunkName: "visnet-hub-chart" */ '@/components/substations/visnet-hubs/main-view/phases-feeders/power-quality/power-quality-chart-filtration'
  );
const FaultComponent = () =>
  import(
    /* webpackChunkName: "visnet-hub-fault" */ '@/components/substations/visnet-hubs/main-view/fault/fault-filtration'
  );
const FaultEventsPanel = () =>
  import(
    /* webpackChunkName: "visnet-hub-fault" */ '@/components/substations/visnet-hubs/main-view/fault/fault-events-panel'
  );
const FaultEventsDefault = () =>
  import(
    /* webpackChunkName: "visnet-hub-fault" */ '@/components/substations/visnet-hubs/main-view/fault/fault'
  );
const ModemLog = () =>
  import(
    /* webpackChunkName: "visnet-hub-modem-log" */ '@/components/substations/visnet-hubs/network/network-modem'
  );
const EditVisnetHub = () =>
  import(
    /* webpackChunkName: "visnet-hub" */ '@/components/substations/visnet-hubs/visnet-hub-edit'
  );
const VisnetFeederDiagram = () =>
  import(
    /* webpackChunkName: "visnet-hub-diagram" */ '@/components/substations/visnet-hubs/visnet-feeder-diagram'
  );

const VISNET_HUBS_ROUTES = [
  {
    path: '/project/:projectCode/substations/:substationCode/visnet_hubs/:externalVisnetHubId',
    component: SubstationVisnetHub,
    meta: { showWide: true },
    props: true,
    children: [
      {
        path: '/',
        component: Charts,
        meta: { showWide: true },
        children: [
          {
            path: 'electrical',
            name: 'ElectricalComponent',
            component: ElectricalChart,
            meta: { showWide: true }
          },
          {
            path: 'environmental',
            name: 'EnvironmentalComponent',
            component: EnvironmentalChart,
            meta: { showWide: true }
          },
          {
            path: 'power_quality',
            name: 'PowerQualityComponent',
            component: PowerQualityChart,
            meta: { showWide: true }
          },
          {
            path: 'faults',
            component: FaultComponent,
            meta: { showWide: true },
            children: [
              {
                path: 'fault_panel',
                name: 'VisnetHubFaultEventsPanel',
                component: FaultEventsPanel,
                meta: { showWide: true }
              },
              {
                path: 'events/phase_number/:phaseNumber/feeder_number/:feederNumber',
                name: 'VisnetHubFaultEventsDefault',
                component: FaultEventsDefault,
                meta: { showWide: true }
              }
            ]
          }
        ]
      },
      {
        path: 'modem_log',
        name: 'ModemLog',
        component: ModemLog,
        meta: { showWide: true }
      }
    ]
  },
  {
    path: '/project/:projectCode/substations/:substationCode/visnet_hubs/:externalVisnetHubId/edit',
    name: 'editVisnetHub',
    component: EditVisnetHub,
    props: true
  },
  {
    path:
      '/project/:projectCode/substations/:substationCode/visnet_hubs/:externalVisnetHubId/feeder_number/:feederNumber/diagrams',
    name: 'VisnetFeederDiagram',
    component: VisnetFeederDiagram,
    meta: { showWide: true }
  }
];
export default VISNET_HUBS_ROUTES;
